import React from 'react';
import UpdatePasswordForm from '../forms/UpdatePasswordForm';

const UpdatePassword = () => {
  return (
    <div className='max-w-[33.625rem]'>
      <div className='mb-6'>
        <h5 className='text-heading-500 !font-medium'>Update Password</h5>
      </div>

      <UpdatePasswordForm />
    </div>
  );
};

export default UpdatePassword;
